/**
 * Keep Loox review/video modals above the sticky header.
 * Widget modals (e.g. loox-iframe-focus-trap) render inside product sections and can
 * sit below the header stacking context; reparent fixed overlays to body and raise z-index.
 */
document.addEventListener('DOMContentLoaded', function () {
  var STYLE_ID = 'fsf-loox-modal-fix-styles';
  var MODAL_MARKERS = '.loox-overlay,[id^="looxOverlay_"],.loox-iframe-focus-trap';

  if (!document.getElementById(STYLE_ID)) {
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.loox-overlay,[id^="looxOverlay_"],.fsf-loox-modal-root{z-index:99999!important}';
    document.head.appendChild(style);
  }

  function isMarker(el) {
    if (!el || el.nodeType !== 1) return false;
    return (
      el.classList.contains('loox-overlay') ||
      el.classList.contains('loox-iframe-focus-trap') ||
      (el.id && el.id.indexOf('looxOverlay_') === 0)
    );
  }

  function findModalRoot(el) {
    var node = el;
    var fixedCandidate = null;

    while (node && node !== document.body) {
      if (
        node.classList &&
        (node.classList.contains('loox-overlay') ||
          (node.id && node.id.indexOf('looxOverlay_') === 0))
      ) {
        return node;
      }

      if (window.getComputedStyle(node).position === 'fixed') {
        fixedCandidate = node;
      }

      node = node.parentElement;
    }

    return fixedCandidate || el;
  }

  function applyFix(el) {
    if (!isMarker(el)) return;

    var root = findModalRoot(el);
    if (!root || root.dataset.fsfLooxFixed === 'true') return;

    root.dataset.fsfLooxFixed = 'true';
    root.classList.add('fsf-loox-modal-root');

    if (root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    root.style.setProperty('z-index', '99999', 'important');
    syncOpenState();
  }

  function scan(node) {
    if (isMarker(node)) applyFix(node);
    if (node.querySelectorAll) {
      node.querySelectorAll(MODAL_MARKERS).forEach(applyFix);
    }
  }

  function syncOpenState() {
    document.body.classList.toggle('loox-modal-open', !!document.querySelector(MODAL_MARKERS));
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(scan);
      if (mutation.removedNodes.length) syncOpenState();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  scan(document.body);
});
